

angular
.module('inkfinder')
.factory('ExceptionApiFormat', function ExceptionApiFormat(
  Session,
  moment,
  Schedule,
  _
) {
  // Public methods
  ExceptionApiFormat.format = format;

  /**
   * @name format
   * @description Pre-process the Sending of an Exception to the API
   * @param {unknown} form Unknown
   * @param {unknown} status Unknown
   * @param {unknown} day Unknown
   * @param {unknown} artist Unknown
   * @return {unknown} Unknown
   */
  function format(form, status, day, artist) {
    let processed = {};
    // Editing
    if (form.id) {
      let start_date;
      let end_date;

      // No Need to Change
      processed.is_off = form.is_off;
      processed.is_exception = form.is_exception;
      processed.artist_hour_id = form.id;
      processed.interval = form.weekly_frequency;
      processed.selected_days = Schedule.generate_selected_days_object(day, true);

      // Editing Is Off
      if (form.is_off) {
        start_date = moment(form.temp.raw_start_date);
        end_date = moment(form.temp.raw_end_date).add(1, 'day');
      } else {
        // Editing Hour Change
        // Hour changes are only Applicable to selected day ONLY, so disregard date data from API.
        start_date = moment(day).format('YYYY-MM-DD');
        end_date = moment(day);

        if (form.temp.raw_start_time >= form.temp.raw_end_time) {
          // Account for time wrap around.
            end_date = moment(day).add(1, 'day');
        }
      }

      processed.start_date = moment(start_date).format('YYYY-MM-DD');
      processed.end_date = moment(end_date).format('YYYY-MM-DD');
      processed.start_time =
      moment(form.temp.raw_start_time).format('HH:mm:ss');
      processed.end_time = moment(form.temp.raw_end_time).format('HH:mm:ss');

      processed.deleted = false;

      if (status.date_range) {
        processed.selected_days = Schedule.generate_selected_days_object(day, true);
      }
    } else {
      // Create New
      processed.is_exception = true;

      // Default Options
      processed.artist_id = artist.id;
      processed.deleted = false;

      // Shared Base between both Options
      processed.interval = 1;
      processed.selected_days = Schedule.generate_selected_days_object(day, true);
      processed.start_date = moment(day).format('YYYY-MM-DD');

      // Off
      if (status.change_shift === 'off') {
        processed.is_off = true;
        processed.start_time = '00:00:00';
        processed.end_time = '00:00:00';
        processed.start_date = moment(day).format('YYYY-MM-DD');
        processed.end_date = moment(day);

        // Only Available when Marking a day as Off
        if (status.date_range) {
          let start = moment(form.temp.raw_start_date);
          let end = moment(form.temp.raw_end_date);

          processed.start_date = moment(start).format('YYYY-MM-DD');
          processed.end_date = moment(end);
        }
        processed.end_date =
        moment(processed.end_date).add(1, 'day').format('YYYY-MM-DD');
      } else {
        // Hour Shift (Default)
        processed.end_date = moment(day).format('YYYY-MM-DD');

        if (form.temp.raw_start_time >= form.temp.raw_end_time) {
          processed.end_date = moment(day).add(1, 'day').format('YYYY-MM-DD');
        }

        processed.end_time = moment(form.temp.raw_end_time).format('HH:mm:ss');
        processed.start_time =
        moment(form.temp.raw_start_time).format('HH:mm:ss');
      }
    }
    return processed;
  }
  return ExceptionApiFormat;
});



// WEBPACK FOOTER //
// ./components/schedule/util/api-format-exception.service.js